import { ReactElement } from 'react';

import { EmailAddress } from '@dreryk/email-address-common-api';

import { BindingCreator } from '@dreryk/react-common';

import { settingsTranslationKeys } from '../../../../translations';

import { StyledAppointmentRequestsEmailField } from './AppointmentRequestsEmailField.styled';

type AppointmentRequestsEmailFormBeanPart = {
   appointmentRequestsEmail: EmailAddress | null;
};

type AppointmentRequestsEmailFieldProps = {
   register: BindingCreator<AppointmentRequestsEmailFormBeanPart>;
   defaultValue: EmailAddress | null;
};

export const AppointmentRequestsEmailField = (props: AppointmentRequestsEmailFieldProps): ReactElement => {
   return (
      <StyledAppointmentRequestsEmailField
         controller={props.register('appointmentRequestsEmail', { required: true })}
         testId={'appointmentRequestsEmail'}
         label={settingsTranslationKeys.appointmentRequestsEmail}
         defaultValue={props.defaultValue}
      />
   );
};
